import {toast} from 'react-toastify';
import { IGetOrdersDayAeroRes, IGetOrdersDaySurfRes } from '@/api/domains/OrderApi/interface/response';
import { api } from '@/api';
import {NAME_STATUS_API_ORDER} from '../../../consts';

export const getOrdersId = (arr: [string, IGetOrdersDaySurfRes | IGetOrdersDayAeroRes][]) => {
    let arrId: Array<number> = [];
    if (arr.length > 1) {
        arr.map((item: any) => item[1].orders.forEach((order: Record<string, any>) => {
            if (order.checked && order.id) {
                arrId.push(order.id)
            }
        }))
    }
    return arrId
}

export const handleClickIsPrint = async (arr: number[]) => {

  if (arr.length === 0) {
    toast.error('Необходимо выбрать заявки!')
    return {contract_pages: []}
  } 

    const response = api.user.getContracts({
      orders: arr
    })
    
    toast.promise(response, {
      pending: NAME_STATUS_API_ORDER.CONTRACTS.PENDING,
      success: {
        render(res: Record<string, any>) {
          const { data } = res
          if (data.contract_pages.length === 0) {
            toast.success('Анкет для подписи нет!')
          }
          return NAME_STATUS_API_ORDER.CONTRACTS.SUCCESS
        }
      },
      error: {
        render(res: Record<string, any>) {
          const { status } = res.data.response
          if (status === 500 || status === 501 || status === 502 || status === 503) {
            toast.error(NAME_STATUS_API_ORDER.CONTRACTS.ERROR_500 + status)
          }
          return NAME_STATUS_API_ORDER.CONTRACTS.ERROR
        }
      }
    })
    
  return response
}